<template>
  <v-container class="snapshots-tab" v-if="!loading">
    <div v-for="snapshot in snapshots" :key="snapshot.SnapshotGroupId">
      <SnapshotItem
        class="mt-6"
        :snapshot="snapshot"
        :status="status"
        :templateStatus="templateStatus"
        :snapshotStatus="snapshotStatus"
        :environmentId="environmentId"
        :isConnected="isConnected"
      />
    </div>
    <div class="text-center mt-2" v-if="snapshots.length === 0">
      <p>There are no snapshots!</p>
    </div>
  </v-container>
  <v-container class="text-center mt-2" v-else>
    <v-progress-circular class="loading" indeterminate color="#881E98"></v-progress-circular>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SnapshotItem from "./SnapshotItem";

export default {
  data() {
    return {
      loading: false,
    };
  },
  props: ["environmentId", "status", "templateStatus", "snapshotStatus", "isConnected"],
  components: { SnapshotItem },
  computed: mapGetters(["snapshots"]),
  methods: mapActions(["getSnapshots", "getConnectedSnapshots"]),
  async beforeMount() {
    this.loading = true;
    !this.isConnected ? await this.getSnapshots(this.environmentId) : await this.getConnectedSnapshots(this.environmentId);
    this.loading = false;
  },
};
</script>